module.exports = __webpack_public_path__ + "resources/img/img_document_recognizer_general1_txt_jp.0f2700d3d889c5d629360014c97501a5.png";